var _defs, _path, _path2, _polygon, _polygon2, _polygon3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChangePw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#47d5cd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.26,86.15h35.48c3.31,0,6.01-2.7,6.01-6.01v-22.15c0-3.31-2.7-6.01-6.01-6.01h-6.22v-7.42c0-6.35-5.17-11.52-11.52-11.52s-11.52,5.17-11.52,11.52v7.42h-6.22c-3.31,0-6.01,2.7-6.01,6.01v22.15c0,3.31,2.7,6.01,6.01,6.01Zm17.74-12.82c-1.79,0-3.24-1.46-3.24-3.24s1.46-3.24,3.24-3.24,3.24,1.46,3.24,3.24-1.46,3.24-3.24,3.24Zm-8.52-28.77c0-4.7,3.82-8.52,8.52-8.52s8.52,3.82,8.52,8.52v7.42h-17.04v-7.42Zm-12.23,13.43c0-1.66,1.35-3.01,3.01-3.01h35.48c1.66,0,3.01,1.35,3.01,3.01v22.15c0,1.66-1.35,3.01-3.01,3.01h-16.24v-7.01c2.72-.67,4.74-3.13,4.74-6.05,0-3.44-2.8-6.24-6.24-6.24s-6.24,2.8-6.24,6.24c0,2.92,2.02,5.38,4.74,6.05v7.01h-16.24c-1.66,0-3.01-1.35-3.01-3.01v-22.15Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M109.62,92.96H40.38c-2.48,0-4.5,2.02-4.5,4.5v15c0,2.48,2.02,4.5,4.5,4.5H109.62c2.48,0,4.5-2.02,4.5-4.5v-15c0-2.48-2.02-4.5-4.5-4.5Zm1.5,19.5c0,.83-.67,1.5-1.5,1.5H40.38c-.83,0-1.5-.67-1.5-1.5v-15c0-.83,.67-1.5,1.5-1.5H109.62c.83,0,1.5,.67,1.5,1.5v15Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "52.8 103.02 50.12 103.6 49.84 100.86 48 100.86 47.71 103.58 45.05 103.02 44.5 104.74 46.95 105.89 45.61 108.25 47.07 109.32 48.91 107.28 50.78 109.32 52.24 108.25 50.86 105.89 53.35 104.74 52.8 103.02"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "63.28 103.02 60.6 103.6 60.32 100.86 58.48 100.86 58.19 103.58 55.53 103.02 54.98 104.74 57.43 105.89 56.09 108.25 57.55 109.32 59.39 107.28 61.26 109.32 62.72 108.25 61.33 105.89 63.83 104.74 63.28 103.02"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "73.75 103.02 71.08 103.6 70.8 100.86 68.96 100.86 68.67 103.58 66.01 103.02 65.46 104.74 67.91 105.89 66.57 108.25 68.03 109.32 69.87 107.28 71.74 109.32 73.2 108.25 71.81 105.89 74.31 104.74 73.75 103.02"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePw);
export default __webpack_public_path__ + "static/media/change_pw.034b655d8ff195fe6407cc0ca7d549c8.svg";
export { ForwardRef as ReactComponent };